module.exports = __webpack_public_path__ + "static/013.thumb-3c980c45d0372e8b177f6e388ed351fe.jpg";